import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './Home.css'
import { AuthProvider } from '../auth/authlib'

function Home(): JSX.Element {
  const navigate = useNavigate()

  useEffect(() => {
    const auth = new AuthProvider()
    auth.requireLogin()
    if (auth.wasRedirectedFromSSO()) {
      navigate(`/prostep${window.location.search}`, { replace: true })
    }
  }, [])

  return (
    <div className="home">
      <h2>Welcome to the ABB POC Dashboard</h2>
      <p className="description">Select a component below to view its detailed information</p>

      <div className="components-grid">
        <Link to="/windchill" className="home-card windchill">
          <div className="card-icon">🌬️</div>
          <h3>Windchill</h3>
          <p>Access Windchill component</p>
        </Link>

        <Link to="/prostep" className="home-card prostep">
          <div className="card-icon">⚙️</div>
          <h3>Prostep</h3>
          <p>Access Prostep component</p>
        </Link>
      </div>
    </div>
  )
}

export default Home
